import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const SystemSecurityUpdateGoodIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"system_security_update_good"} ref={ref}/>
});

SystemSecurityUpdateGoodIcon.displayName = "SystemSecurityUpdateGoodIcon";
